import React, { useState, useEffect } from 'react';
import { Drawer, Table, Select, Switch, Button, Modal } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { getColumns } from '../BulkEdit/bulkEditColumns';
import globalData from "../../../../config/global_data";
import BulkAttributeList from './bulkAttributeList';
import ApplyAllAttributeList from './applyAllAttributeList';
import common_api from '../../../../config/common_api';
import { triggerNotification } from '../../notify';

const { Option } = Select;

const BulkEditDrawer = ({ open, onClose, selectedData, setisloader, onUpdateEnrich, globalList, setGlobalList }) => {
    const [selectedField, setSelectedField] = useState(null);
    const [applyToAll, setApplyToAll] = useState(false);
    const [descriptionValue, setDescriptionValue] = useState('');
    const [tableData, setTableData] = useState([]);
    const [attributes, setAttributes] = useState([]);
    const [parsedSelectedField, setParsedSelectedField] = useState(null);
    const [tabActive, setTabActive] = useState(null);
    const [isConfirmVisible, setIsConfirmVisible] = useState(false);
    const [nextCheckedState, setNextCheckedState] = useState(false);
    const [savedattributes, setSavedattributes] = useState(null);
    const [removedValues, setRemovedValues] = useState(null);
    const [isAction, setIsAction] = useState(false);
    const [applyToAllField, setApplyToAllField] = useState(false);
    const [bestMatchKey, setBestMatchKey] = useState(null);




    const setNewTableData = async () => {
        let xmappedData = selectedData.map((item, index) => {
            let custom_field_set = [];

            if (item.custom_fields && globalData?.attribute_tree?.length > 0) {
                custom_field_set = globalData.attribute_tree.map((attr) => {
                    let value = [{}];
                    const pattern = new RegExp(attr.attri_pattern);
                    const return_data = item.custom_fields.filter(initem =>
                        pattern.test(initem.name ?? initem.key)
                    );
                    for (let k = 0; k < return_data.length; k++) {
                        const element = return_data[k];


                        let indexvalue = (element.name ?? element.key).replace(/\D/g, '') || 1;
                        value[indexvalue - 1] = {
                            val: element.values ?? element.value,
                            key: element.id,
                            id: element.id,
                            name: element.name,
                            store: item.store,
                            store_id: item.store_id,
                            prod_id: item.prod_id,
                            new_val: '',

                        };
                    }
                    return {
                        ...attr,
                        values: value,
                        pattern: attr.attri_pattern
                    };
                });
            }
            const newItem = {
                key: item.key,
                name: item.sapName,
                sku: item.sapSku,
                store: item.store,
                description: '',
                custom_fields: item.custom_fields,
                custom_field_set,
                new_values: '',
                store_id: item.store_id,
                prod_id: item.prod_id,
            };

            if (index === 0) setTabActive(newItem);
            return newItem;
        });

        setTableData(xmappedData);
    };

    useEffect(() => {

        if (selectedData?.length > 0) {
            setNewTableData();
        }
    }, [selectedData]);

    useEffect(() => {
        if (savedattributes) { //&& savedattributes.savedData && savedattributes.savedData.length > 0) {
            setIsAction(true)
        }
        else {
            setIsAction(false)
        }

    }, [savedattributes]);   

    useEffect(() => {
        if (globalData && globalData.attribute_tree && globalData.attribute_tree.length > 0) {
            setAttributes(globalData.attribute_tree);
        }
    }, []);


    const handleSaveAndPublish = async (is_open) => {
       
        const input = savedattributes
        const removed_custom_fields = [];
        const groupedData = {};

        // Process each group
        for (const key in input) {
            const items = input[key];

            for (const item of items) {
                const storeId = item.store_id;
                const prodId = item.prod_id;
                const store = item.store || "UAT";
                const id = item.id || null;
                const name = item.name || item.tempKey;
                const value = item.value;

                // Removed fields
                if (item.removed) {
                    if (id != null && storeId && prodId) {
                        removed_custom_fields.push({
                            store_id: storeId,
                            store: store,
                            product_id: parseInt(prodId),
                            id: id
                        });
                    }
                } else {
                    const key = `${prodId}_${storeId}`;
                    if (!groupedData[key]) {
                        groupedData[key] = {
                            product_id: parseInt(prodId),
                            store_id: storeId,
                            custom_fields: []
                        };
                    }

                    if (name && value) {
                        let jsondata = {

                            id: id,
                            name: name,
                            value: value

                        }
                        if (!id)
                            delete jsondata.id

                        groupedData[key].custom_fields.push(jsondata);

                    }
                }
            }
        }

        const output = {
            removed_custom_fields,
            data: Object.values(groupedData)
        };
        setisloader(true)
        let responsedata = await common_api.update_enrich_product(output)
        if (responsedata) {
           
            let alldata = await common_api.set_all_madded_data_to_variables_bulk(globalList, responsedata, false)
           
            
            if (alldata) {
                await setGlobalList(alldata)
            }
            if (!is_open) {
                onClose()
            }
            triggerNotification(responsedata)
        }
        setisloader(false)
    };

    const handleTextChange = (val, index) => {
        const newData = [...tableData];
        newData[index].description = val;
        setTableData(newData);
    };

    return (
        <Drawer
            className='BulkEditDrawer'
            title={`Bulk Edit (${tableData.length})`}
            width={'calc(100% - 256px)'}
            onClose={onClose}
            open={open}
            extra={
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button disabled={!isAction} onClick={e => handleSaveAndPublish(true)}>Save & Continue Editing</Button>
                    <Button disabled={!isAction} type="primary" onClick={e => handleSaveAndPublish(false)}>Save Changes</Button>
                </div>
            }
        >
            <div className={`selectedFieldBoxRow ${selectedField ? "RowFlex" : ""}`}>
                <div className={`${selectedField ? "selectedFieldBox" : ""}`}>
                    <div style={{ marginBottom: 16 }}>
                        <span style={{ marginRight: 8, fontWeight: 500 }}>
                            * Field To Edit{' '}
                            <span style={{ color: '#aaa' }} title="Select the field you want to bulk edit">ⓘ</span>
                        </span>
                        <Select
                            placeholder="Please select which field to bulk edit"
                            style={{ width: 300 }}
                            onChange={(val) => {
                                const parsed = JSON.parse(val.value);
                                setSelectedField(val);
                                setParsedSelectedField(parsed);
                                setDescriptionValue('');
                                setApplyToAll(false);
                            }}
                            value={selectedField}
                            labelInValue
                        >
                            {attributes.map((attr, index) => (
                                <Option key={index} value={JSON.stringify(attr)}>
                                    {attr.name}
                                </Option>
                            ))}
                        </Select>
                    </div>

                    {selectedField && (
                        <div className='BulkTogglebuton' style={{ display: 'flex', marginBottom: 8 }}>
                            <span style={{ marginRight: 8 }}>Apply to all ({tableData.length})</span>
                            <Switch
                                checked={applyToAll}
                                onChange={(checked) => {
                                    if (checked) {
                                        setNextCheckedState(true);
                                        setIsConfirmVisible(true);
                                    } else {
                                        setApplyToAll(false);
                                    }
                                }}
                            />
                        </div>
                    )}

                    {!selectedField &&
                        <Table
                            className='DrawerTable'
                            columns={getColumns(
                                selectedField,
                                applyToAll ? descriptionValue : null,
                                handleTextChange
                            )}
                            dataSource={tableData}
                            pagination={false}
                            rowKey="key"
                        />
                    }

                    {selectedField &&
                        <div className="DrawerTableList">
                            {tableData.map(item => (
                                <div
                                    key={item.key}
                                    className={`drawer-row ${tabActive?.key === item.key ? 'active' : ''} ${applyToAll && item.key !== bestMatchKey ? 'disabled' : ''}`}
                                    // className={`drawer-row ${tabActive?.key === item.key ? 'active' : ''}`}
                                    onClick={() => {
                                        if (applyToAll && item.key !== bestMatchKey) return;
                                        setTabActive(item);
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="drawer-info">
                                        <div className="drawer-title">{item.name}</div>
                                        <div className="drawer-sub">{item.sku} – {item.store}</div>
                                    </div>
                                    <RightOutlined />
                                </div>
                            ))}
                        </div>
                    }
                </div>

                {!applyToAll && selectedField && tableData && tableData.map(item => (
                    <div
                        key={item.key}
                        className='selectedFieldBoxRightBox'
                        style={{ display: tabActive?.key === item.key ? 'block' : 'none' }} // 👈 show only the active one
                    >
                        <div className='selectedAttriList'>
                            <BulkAttributeList
                                tabkey={item.key}
                                setSavedattributes={setSavedattributes}
                                tabActive={item}
                                selectedField={selectedField}
                                tableData={tableData}
                                setTabActive={setTabActive}
                                setIsAction={setIsAction}
                                applyToAll={applyToAll}
                            />
                        </div>
                    </div>
                ))}
                {applyToAll && selectedField && tableData &&
                    <div
                        className='selectedFieldBoxRightBox'
                    >
                        <div className='selectedAttriList'>
                            <ApplyAllAttributeList
                                setSavedattributes={setSavedattributes}
                                savedattributes={savedattributes}
                                tabActive={tabActive}
                                selectedField={selectedField}
                                tableData={tableData}
                                setTabActive={setTabActive}
                                setIsAction={setIsAction}
                                applyToAll={applyToAll}
                            />
                        </div>
                    </div>
                }
            </div>

            <Modal
                className='CustomApplyModal'
                title="Apply to All"
                open={isConfirmVisible}
                centered
                onOk={() => {
                    if (!parsedSelectedField) return;

                    let bestMatch = tableData.reduce((acc, item) => {
                        const attrData = item.custom_field_set?.find(attr =>
                            attr.attri_pattern === parsedSelectedField.attri_pattern
                        );
                        const filledCount = attrData?.values?.filter(v => v?.val)?.length || 0;
                        if (filledCount > acc.maxCount) {
                            return { maxCount: filledCount, item };
                        }
                        return acc;
                    }, { maxCount: -1, item: null });

                    if (bestMatch.item) {
                        const sourceAttr = bestMatch.item.custom_field_set.find(attr =>
                            attr.attri_pattern === parsedSelectedField.attri_pattern
                        );
                        const maxValues = sourceAttr?.values || [];

                        const newTableData = tableData.map(item => {
                            const isBestMatch = item.key === bestMatch.item.key;

                            const attrSet = item.custom_field_set?.find(attr =>
                                attr.attri_pattern === parsedSelectedField.attri_pattern
                            );

                            if (attrSet) {
                                attrSet.values = maxValues.map((sourceVal, idx) => {
                                    const existingVal = attrSet.values?.[idx] || {};

                                    return {
                                        ...existingVal,
                                        new_val: sourceVal?.new_val || '',
                                        key: existingVal.key || null,
                                        id: existingVal.id || null,
                                        name: existingVal.name || sourceVal.name || parsedSelectedField.name,
                                        store: item.store,
                                        store_id: item.store_id,
                                        prod_id: item.prod_id,
                                        disabled: !isBestMatch
                                    };
                                });
                            }

                            return { ...item };
                        });

                        setTableData(newTableData);
                        setApplyToAll(true);
                        setTabActive(bestMatch.item);
                        setBestMatchKey(bestMatch.item.key);
                    }

                    setIsConfirmVisible(false);
                }}

                onCancel={() => {
                    setIsConfirmVisible(false);
                    setNextCheckedState(false);
                }}
                okText="Apply To All"
                cancelText="Cancel"
            >
                <div>Are you sure you want to apply this change to all selected items?</div>
            </Modal>
        </Drawer>
    );
};

export default BulkEditDrawer;
